// extracted by mini-css-extract-plugin
export var item = "techtime-item-module--item--Td21g";
export var button = "techtime-item-module--button--1cYWQ";
export var wrapper = "techtime-item-module--wrapper--QP6HD";
export var title = "techtime-item-module--title--XScFx";
export var descriptionWrapper = "techtime-item-module--description-wrapper--eptOS";
export var info = "techtime-item-module--info--PcXMW";
export var period = "techtime-item-module--period--vnN9d";
export var periodIcon = "techtime-item-module--period-icon--IR7LF";
export var selected = "techtime-item-module--selected--3o5Y7";